'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var EventEmitter = require('events').EventEmitter;

var noop = require('lodash.noop');

var Connection = require('interface-connection').Connection;

var toPull = require('stream-to-pull-stream');

var SPDY_CODEC = require('./spdy-codec');

module.exports =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Muxer, _EventEmitter);

  function Muxer(conn, spdy) {
    var _this;

    _classCallCheck(this, Muxer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Muxer).call(this));
    _this.spdy = spdy;
    _this.conn = conn;
    _this.multicodec = SPDY_CODEC;
    spdy.start(3.1); // The rest of the API comes by default with SPDY

    spdy.on('close', function () {
      _this.emit('close');
    });
    spdy.on('error', function (err) {
      _this.emit('error', err);
    }); // needed by other spdy impl that need the response headers
    // in order to confirm the stream can be open

    spdy.on('stream', function (stream) {
      stream.respond(200, {});
      var muxedConn = new Connection(toPull.duplex(stream), _this.conn);

      _this.emit('stream', muxedConn);
    });
    return _this;
  } // method added to enable pure stream muxer feeling


  _createClass(Muxer, [{
    key: "newStream",
    value: function newStream(callback) {
      var _this2 = this;

      if (!callback) {
        callback = noop;
      }

      var conn = new Connection(null, this.conn);
      this.spdy.request({
        method: 'POST',
        path: '/',
        headers: {}
      }, function (err, stream) {
        if (err) {
          return callback(err);
        }

        conn.setInnerConn(toPull.duplex(stream), _this2.conn);
        callback(null, conn);
      });
      return conn;
    }
  }, {
    key: "end",
    value: function end(cb) {
      this.spdy.destroyStreams();
      this.spdy.end(cb);
    }
  }]);

  return Muxer;
}(EventEmitter);